import {
    Avatar,
    Box,
    Button,
    Container,
    Group,
    Paper,
    Stack,
    Text,
    TextInput,
    Title,
    Pagination,
    Loader,
    Center,
    Modal,
    Divider,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import {
    IconSearch,
    IconBriefcase,
    IconMapPin,
    IconPhone,
    IconMail,
    IconScale,
    IconIdBadge2,
    IconUserShield,
    IconLock,
} from "@tabler/icons-react";

import { useEffect, useState } from "react";
import Newnavbar from "../Components/Navbar/Newnavbar";
import { Userauthcontexthooks } from "../Hooks/Userauthcontexthooks";

const Viewallprofessionals = () => {

    const { user } = Userauthcontexthooks();
    const isMobile = useMediaQuery("(max-width: 900px)");
    const [profiles, setProfiles] = useState([]);
    const [loading, setLoading] = useState(true);

    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const [search, setSearch] = useState("");

    const [opened, setOpened] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [userDetails, SetUserDetails] = useState(''); // for getting individual user details to check the profile completion for date alert feature and also to show the details in profile section of navbar.

    const getProfiles = async (currentPage = 1, searchValue = "") => {

        setLoading(true);

        try {

            const res = await fetch(
                `https://cdr-backend.onrender.com/v2/get-users-profiles?page=${currentPage}&limit=12&search=${searchValue}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${user}`,
                    },
                }
            );

            const data = await res.json();

            if (res.status === 200) {

                setProfiles(data.userProfiles);
                setTotalPages(data.totalPages);

            }

        } catch (error) {
            console.log(error);
        }

        setLoading(false);
    };

    useEffect(() => {
        const getProfiles = async (currentPage = 1, searchValue = "") => {

            setLoading(true);

            try {

                const res = await fetch(
                    `https://cdr-backend.onrender.com/v2/get-users-profiles?page=${currentPage}&limit=12&search=${searchValue}`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${user}`,
                        },
                    }
                );

                const data = await res.json();

                if (res.status === 200) {

                    setProfiles(data.userProfiles);
                    setTotalPages(data.totalPages);

                }

            } catch (error) {
                console.log(error);
            }

            setLoading(false);
        };
        if (user) {
            getProfiles(page, search);
        }

    }, [user, page, search]);

    useEffect(() => { // get individual user details
        const GetIndividualUser = async () => {
            const res = await fetch("https://cdr-backend.onrender.com/get/user-details", {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': `Bearer ${user}`
                }
            });

            const Result = await res.json();
            if (res.status === 200) {
                SetUserDetails(Result.ExistingUser);
                return
            } else {
                return;
            }
        }
        if (user) {
            GetIndividualUser();
        }
    }, [user])

    const OpenProfile = (item) => {
        setSelectedUser(item);
        setOpened(true);
    };

    return (
        <>
            <Box
                style={{
                    minHeight: "100vh",
                    background:
                        "linear-gradient(135deg,#020617 0%,#0f172a 40%,#111827 100%)",
                    position: "relative",
                    overflow: "hidden",
                }}
            >

                {/* BACKGROUND GLOW */}

                <Box
                    style={{
                        position: "absolute",
                        width: 500,
                        height: 500,
                        borderRadius: "50%",
                        background: "rgba(59,130,246,0.15)",
                        filter: "blur(120px)",
                        top: -100,
                        right: -100,
                    }}
                />

                <Box
                    style={{
                        position: "absolute",
                        width: 400,
                        height: 400,
                        borderRadius: "50%",
                        background: "rgba(168,85,247,0.15)",
                        filter: "blur(120px)",
                        bottom: -100,
                        left: -100,
                    }}
                />

                {/* MAIN CONTENT */}

                <Box
                    px={{ base: "md", md: "xl" }}
                    py={{ base: "md", md: "lg" }}
                    style={{
                        position: "relative",
                        zIndex: 10,
                        paddingBottom: 100,
                    }}
                >

                    <Newnavbar />

                    <Container size="xl" mt="md" mb="xl" style={{
                        overflow: "hidden",
                    }}>

                        {/* HEADER */}

                        <Group justify="space-between" mb="xl">

                            <Box>
                                <Title c="white">
                                    Legal Professionals
                                </Title>

                                <Text c="#94a3b8" mt={4}>
                                    Find advocates, clerks & legal experts
                                </Text>
                            </Box>

                        </Group>

                        {/* SEARCH */}

                        <Paper
                            radius="25px"
                            p="md"
                            mb="xl"
                            style={{
                                background: "rgba(255,255,255,0.06)",
                                border: "1px solid rgba(255,255,255,0.08)",
                                backdropFilter: "blur(20px)",
                            }}
                        >

                            <TextInput
                                placeholder="Search by name, specialization, court..."
                                leftSection={<IconSearch size={18} />}
                                radius="xl"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        setPage(1);
                                        getProfiles(1, search);
                                    }
                                }}
                                styles={{
                                    input: {
                                        background: "rgba(255,255,255,0.04)",
                                        border: "1px solid rgba(255,255,255,0.08)",
                                        color: "white",
                                        height: 50,
                                    },
                                }}
                            />

                        </Paper>

                        {/* LOADING */}

                        {
                            loading ? (
                                <Center mt={100}>
                                    <Loader color="blue" />
                                </Center>
                            ) : (
                                <Stack gap="lg">

                                    {
                                        profiles.map((item, index) => (

                                            <Paper
                                                key={index}
                                                radius="30px"
                                                p="xl"
                                                style={{
                                                    background: "rgba(255,255,255,0.08)",
                                                    border: "1px solid rgba(255,255,255,0.08)",
                                                    backdropFilter: "blur(20px)",
                                                }}
                                            >

                                                <Group justify="space-between" align="center">

                                                    <Group gap="md" wrap="nowrap">

                                                        <Avatar
                                                            size={70}
                                                            radius="xl"
                                                            color="blue"
                                                            name={item?.Fullname}
                                                        />

                                                        <Box>

                                                            <Group gap="xs">

                                                                <Text
                                                                    fw={700}
                                                                    c="white"
                                                                    size="lg"
                                                                >
                                                                    {item?.Fullname}
                                                                </Text>

                                                                {/* <Badge
                                                                    color={
                                                                        item?.AccountType === "Premium"
                                                                            ? "yellow"
                                                                            : "gray"
                                                                    }
                                                                    variant="light"
                                                                >
                                                                    {item?.AccountType}
                                                                </Badge> */}

                                                            </Group>

                                                            <Text size="sm" c="#94a3b8" mt={2}>
                                                                {item?.clerkid ? "Clerk" : "Advocate"}
                                                            </Text>

                                                            <Group gap="xs" mt={8}>

                                                                <IconBriefcase
                                                                    size={15}
                                                                    color="#94a3b8"
                                                                />

                                                                <Text size="sm" c="#94a3b8">
                                                                    {item?.specialization || "Legal Professional"}
                                                                </Text>

                                                            </Group>

                                                            <Group gap="xs" mt={5}>

                                                                <IconMapPin
                                                                    size={15}
                                                                    color="#94a3b8"
                                                                />

                                                                <Text size="sm" c="#94a3b8">
                                                                    {item?.city || "Delhi"},
                                                                    {" "}
                                                                    {item?.state || "India"}
                                                                </Text>

                                                            </Group>

                                                        </Box>

                                                    </Group>

                                                    <Button
                                                        radius="xl"
                                                        variant="gradient"
                                                        gradient={{ from: "blue", to: "cyan" }}
                                                        onClick={() => OpenProfile(item)}
                                                    >
                                                        View Full Details
                                                    </Button>

                                                </Group>

                                            </Paper>

                                        ))
                                    }

                                </Stack>
                            )
                        }
                        {/* PAGINATION */}

                        <Center mt={40}>
                            {
                                isMobile ? (
                                    <Group justify="center" mt="xl">
                                        <Button
                                            variant="light"
                                            radius="xl"
                                            disabled={page === 1}
                                            onClick={() => setPage((prev) => prev - 1)}
                                        >
                                            ← Previous
                                        </Button>

                                        <Button
                                            variant="light"
                                            radius="xl"
                                            disabled={page === totalPages}
                                            onClick={() => setPage((prev) => prev + 1)}
                                        >
                                            Next →
                                        </Button>
                                    </Group>
                                ) : (
                                    <Pagination
                                        total={totalPages}
                                        value={page}
                                        onChange={setPage}
                                        radius="xl"
                                        style={{ cursor: "pointer" }}
                                    />
                                )
                            }
                            {/* <Pagination
                                total={totalPages}
                                value={page}
                                onChange={(newPage) => {
                                   // console.log("Selected Page:", newPage);
                                    setPage(newPage);
                                }}
                                radius="xl"
                                withPages={false}
                                //size={'lg'}
                                //withEdges
                                //style={{cursor: "pointer"}}
                            /> */}

                        </Center>

                    </Container>

                </Box>

            </Box>

            {/* VIEW DETAILS MODAL */}

            <Modal
                opened={opened}
                onClose={() => setOpened(false)}
                title="Professional Details"
                centered
                size="lg"
                radius="25px"
            >

                {
                    selectedUser && (

                        <Stack>

                            <Group wrap="nowrap">

                                <Avatar
                                    size={80}
                                    radius="100%"
                                    color="blue"
                                    name={selectedUser?.Fullname}
                                />

                                <Box>

                                    <Group gap="xs">

                                        <Title order={3}>
                                            {selectedUser?.Fullname}
                                        </Title>

                                        {/* <Badge
                                            color={
                                                selectedUser?.AccountType === "Premium"
                                                    ? "yellow"
                                                    : "gray"
                                            }
                                        >
                                            {selectedUser?.AccountType}
                                        </Badge> */}

                                    </Group>
                                    {
                                        selectedUser?.clerkid !== "" && <Text c="dimmed">
                                            Clerk id: {selectedUser?.clerkid || "N/A"}
                                        </Text>
                                    }

                                    <Text c="dimmed">
                                        {selectedUser?.specialization || "Legal Professional"}
                                    </Text>
                                    <Text c="dimmed">
                                        City: {selectedUser?.city || "No Address"}
                                        {" || "}
                                        State: {selectedUser?.state || "No Address"}
                                    </Text>

                                </Box>

                            </Group>

                            <Divider />

                            {/* CONTACT DETAILS */}

                            <Paper
                                p="md"
                                radius="xl"
                                withBorder
                                style={{
                                    position: "relative",
                                    overflow: "hidden",
                                }}
                            >

                                {
                                    userDetails?.AccountType === "" && (
                                        <Box
                                            style={{
                                                position: "absolute",
                                                inset: 0,
                                                backdropFilter: "blur(8px)",
                                                background: "rgba(255,255,255,0.08)",
                                                zIndex: 10,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                flexDirection: "column",
                                                gap: 10,
                                            }}
                                        >
                                            <IconLock size={28} />

                                            <Text fw={700}>
                                                Upgrade to Premium to unlock contact details.
                                            </Text>
                                        </Box>
                                    )
                                }

                                <Stack gap="md">

                                    <Group>
                                        <IconPhone size={18} />
                                        <Text>{selectedUser?.PhoneNumber}</Text>
                                    </Group>

                                    <Group>
                                        <IconMail size={18} />
                                        <Text>{selectedUser?.Email}</Text>
                                    </Group>

                                    <Group align="flex-start">
                                        <IconMapPin size={18} />
                                        <Text>
                                            {selectedUser?.officeaddress || "No Address"}
                                        </Text>
                                    </Group>

                                </Stack>

                            </Paper>

                            {/* PROFESSIONAL DETAILS */}

                            <Paper
                                p="md"
                                radius="xl"
                                withBorder
                            >

                                <Stack gap="md">

                                    <Group>
                                        <IconScale size={18} />
                                        <Text>
                                            Experience:
                                            {" "}
                                            {selectedUser?.experience || "0 Years"}
                                        </Text>
                                    </Group>

                                    <Group>
                                        {/* <IconBuildingCourt size={18} /> */}
                                        <IconScale size={18} />
                                        <Text>
                                            Court:
                                            {" "}
                                            {selectedUser?.practicecourt || "N/A"}
                                            {" "}
                                            {selectedUser?.courtname || "N/A"}
                                        </Text>
                                    </Group>
                                    <Group>
                                        <IconIdBadge2 size={18} />
                                        <Text>
                                            Bar Council No:
                                            {" "}
                                            {selectedUser?.barcouncilnumber || "N/A"}
                                        </Text>
                                    </Group>

                                    <Group>
                                        <IconUserShield size={18} />
                                        <Text>
                                            Working Under:
                                            {" "}
                                            {selectedUser?.workingunder || "N/A"}
                                        </Text>
                                    </Group>
                                    <Group>
                                        <IconUserShield size={18} />
                                        <Text>
                                            Department Section:
                                            {" "}
                                            {selectedUser?.departmentsection || "N/A"}
                                        </Text>
                                    </Group>
                                    {/* <Group>
                                        <IconUserShield size={18} />
                                        <Text>
                                            Clerk id:
                                            {" "}
                                            {selectedUser?.departmentsection || "N/A"}
                                        </Text>
                                    </Group> */}

                                </Stack>

                            </Paper>

                        </Stack>

                    )
                }

            </Modal>
        </>
    );
};

export default Viewallprofessionals;